<a [id]="'menu-item-' + label" mat-list-item class="document-link" (click)="open()">
	<mat-icon>{{ icon }}</mat-icon>
	<span class="document-link-text">{{ label | translate }}</span>
</a>
